import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'lifedi-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {
  @Input() lastPath: string = null;
  pathArr: any = [];
  constructor() { }

  ngOnInit(): void {
    this.getPath();
  }

  getPath() {
    const path = window.location.pathname.replace("([^/]+)(?:\\.[^\\.]+$|/)", "g");
    let arr = path.split('/');
    let tempPathName;
    arr.forEach((e, i) => {
      this.pathArr[i] = {};
      if (e === '') {
        tempPathName = '';
        this.pathArr[i].pathName = 'home'
        this.pathArr[i].link = ''
      } else {
        tempPathName += '/' + e;
        this.pathArr[i].pathName = e
        this.pathArr[i].link = tempPathName
      }
    });
    // // console.log(this.pathArr);
  }
}
